<template>
	<div class="wrap">
		<div class="head">
			<div class="center"><img class="logo" src="../../assets/images/logo_gys.png" /></div>
		</div>
		<div class="main">
			<img class="bg" src="../../assets/images/login_banner.png" />
			<div class="login_main">
				<div class="login_type">
					<p :class="login_type==1?'tab active':'tab'" @click="changeLoginType('1')">扫码登录</p>
					<p :class="login_type==2?'tab active':'tab'" @click="changeLoginType('2')">账户登录</p>
				</div>
				<div class="code_login" v-show="login_type==1" v-loading="loadingCode">
					<img class="code" :src="imageCode" />
					<p class="txt">打开手机微信，扫描二维码</p>
				</div>
				<div class="account_login" v-show="login_type==2">
					<div v-if="!is_code_login">
						<el-input v-model="login_phone" placeholder="手机号登录" class="el_input lin">
							<p class="icons" slot="prefix"><i class="iconfont icon-yonghu"></i></p>
						</el-input>
						<el-input v-model="login_pwd" placeholder="密码" class="el_input lin" type="password">
							<p class="icons" slot="prefix"><i class="iconfont icon-clock"></i></p>
						</el-input>
					</div>
					<div v-else>
						<el-input v-model="login_phone" placeholder="输入手机号" class="el_input el_in2">
							<p slot="prefix" class="txts">手机号码</p>
						</el-input>
            <el-input v-model="reg_captcha" placeholder="请输入图形验证码" class="el_input el_in2">
              <p slot="prefix" class="txts">验证码</p>
            </el-input>
            <div class="mt-4">
              <img class="w-40" :src="captcha_url" @click="refreshCaptcha" />
            </div>
						<el-input v-model="login_code" placeholder="短信验证码" class="el_input el_in2">
							<p slot="prefix" class="txts">验证码</p>
							<p slot="suffix" class="getcode" @click="getPhoneCode('2')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
						</el-input>
					</div>
					<p class="change_way">
						<el-checkbox v-model="remember_pwd">记住密码</el-checkbox>
						<span @click="is_code_login=!is_code_login;refreshCaptcha()">
							{{is_code_login?'账号密码登录':'验证码登录'}}
						</span>
					</p>
					<p class="login_btn"  @click="loginSubmit">登录</p>
				</div>
				<div class="code_login" v-show="login_type==3" v-loading="loadingCode">
					<img class="code" :src="imageCode" />
					<p class="txt">扫码关注公众号并绑定手机号</p>
				</div>
				<p class="go_register">还没账户？<a @click="$router.push('./register')">去注册</a></p>
			</div>
		</div>
		<div class="foot">
			<p>地址：广东省深圳市龙华区XX街道000室</p>
			<p>XXX有限公司  版权所有2022-2029  粤ICP备00000000号</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import common from '../../assets/js/utils/common';
import config from "../../assets/js/conf/config";

export default {
	name: "login",
	data(){
		return{
			is_code_login:false,
			login_type:1,
			login_phone:"",
			login_pwd:"",
			remember_pwd:false,
			login_code:"",
			imageCode:"",
			loadingCode:false,
			is_get_phone_code:false,
			phone_second:60,
			is_login_submit:false,
			checkBindTimer:null,
			userinfo:"",
      captcha_url:"",
      reg_captcha: "",
		}
	},
	components:{
		
	},
	mounted(){
		this.checkLoginCookie()
	},
	computed:{
		...mapState({
			ucmenu:(state)=>state.login.ucmenu,
		}),
	},
	created(){
		this.changeLoginType('1')
	},
	methods:{
		...mapActions({
			getCodeData:"login/getCodeData",
			getQrcodeData:"login/getQrcodeData",
			checkWxBind:"login/checkWxBind",
			DoAccountLogin:"login/DoAccountLogin",
			DoCodeLogin:"login/DoCodeLogin",
			getUcenterMenu:"login/getUcenterMenu",
		}),
		changeLoginType(type){//切换登录方式  1，扫码登录  2，账号登录
			if(type==1){
				this.login_type = 1
				setTimeout(()=>{this.loadingCode = true},100)
				this.getLoginCode('',true,'1')
			}else{
				this.login_type = 2
				clearTimeout(this.checkBindTimer)
			}
		},
		getUCmenu(){
			this.getUcenterMenu({data:{},success:(res)=>{
				if(res.status==200){
					// console.log('getUCmenu',res)
					// console.log(this.ucmenu)
					// this.employeeData.data = res.data
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		loginSubmit(){//登录提交
			let that = this
			if(!that.login_phone){
				that.$message({message: '请输入手机号码',type: 'error',});
				return false
			}
			if(!that.is_code_login){//账号密码登录
				if(!that.login_pwd){
					that.$message({message: '请输入密码',type: 'error',});
					return false
				}
				if(!that.is_login_submit){
					that.is_login_submit = true
					that.DoAccountLogin({data:{
							mobile:that.login_phone,
							password:that.login_pwd,
						},success:(res)=>{
						if(res.code===200){
							// console.log('account login success',res)
							that.userinfo = res.data.userinfo
							that.avatar = res.data.userinfo.avatar
							that.setLoginCookie()
							that.$message({message: res.msg,type: 'success',});
							that.getUCmenu()
							if(res.data.userinfo.is_follow==0){
								that.login_type = 3
								that.getLoginCode(that.login_phone,true)
							}else{
								let timer = setInterval(()=>{
									
									// console.log(that.ucmenu)
									if(that.ucmenu.length>0){
										clearInterval(timer)
										setTimeout(()=>{
											that.$router.replace(that.ucmenu[0].url +'?menuId='+that.ucmenu[0].menu_id)
										},300)
									}
								},100)
							}
						} else {
							that.$message({message: res.msg,type: 'error',});
							that.is_login_submit = false
						}
					}})
				}
			}else{//短信验证码登录
				if(!that.login_code){
					that.$message({message: '请获取短信验证码',type: 'error',});
					return false
				}
				if(!that.is_login_submit){
					that.is_login_submit = true
					that.DoCodeLogin({data:{
							mobile:that.login_phone,
							code:that.login_code,
						},success:(res)=>{
						if(res.code===200){
							console.log('code login success',res)
							that.userinfo = res.data.userinfo
							that.avatar = res.data.userinfo.avatar
							that.$message({message: res.msg,type: 'success',});
							that.getUCmenu()
							if(res.data.userinfo.is_follow==0){
								that.login_type = 3
								that.getLoginCode(that.login_phone,true)
							}else{
								let timer = setInterval(()=>{
									if(that.ucmenu.length>0){
										clearInterval(timer)
										setTimeout(()=>{
											that.$router.replace(that.ucmenu[0].url +'?menuId='+that.ucmenu[0].menu_id)
										},300)
									}
								},100)
							}
						} else {
							that.$message({message: res.msg,type: 'error',});
							that.is_login_submit = false
						}
					}})
				}
			}
		},
		getPhoneCode(ev){//获取短信验证码
			let that = this
			let phone = that.login_phone
			if(!common._verify_mobile(phone)){
				that.$message({message: '请输入正确手机号',type: 'error',});
				return false
			}
      if(!this.reg_captcha){
        this.$message({message: '请先输入图形验证码',type: 'error',});
        return false
      }
			if(!that.is_get_phone_code){
				that.is_get_phone_code = true
				this.getCodeData({data:{
						mobile:phone,
						event:ev,
            captcha: this.reg_captcha,
					},success:(res)=>{
					if(res.code===200){
						console.log('get phone code',res)
						this.$message({message: '发送成功~',type: 'success',});
						let timer = setInterval(()=>{
							this.phone_second -= 1
							if(this.phone_second == 0){
								clearInterval(timer)
								this.phone_second = 60
								this.is_get_phone_code = false
							}
						},1000)
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_get_phone_code = false
					}
				}})
			}
			
		},
		getLoginCode(phone='',isCheck=false,type='2'){//获取登录二维码,type=1表示直接通过二维码扫码登录，不需要传手机号
			this.getQrcodeData({data:{
					mobile:phone,
					level:'3',
					bind_uid:'0',
					type:type,
				},success:(res)=>{
				if(res.code===200){
					console.log('get qr code',res)
					this.imageCode = res.msg.ticket_img
					setTimeout(()=>{this.loadingCode = false},1000)
					if(isCheck){
						this.int_uid = res.msg.int_uid
						this.checkBind(res.msg.int_uid)
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		checkBind(id){//检测是否微信绑定成功
			this.checkWxBind({data:{
					int_uid:id,
				},success:(res)=>{
				console.log('check login',res)
				if(res.code===200){
					this.userinfo = res.data.userinfo
					this.avatar = res.data.userinfo.avatar
					this.getUCmenu()
					this.$message({message: res.msg,type: 'success',});
					let timer = setInterval(()=>{
						if(this.ucmenu.length>0){
							clearInterval(timer)
							setTimeout(()=>{
								this.$router.replace(this.ucmenu[0].url +'?menuId='+this.ucmenu[0].menu_id)
							},300)
						}
					},100)
				} else {
					this.checkBindTimer = setTimeout(()=>{
						this.checkBind(this.int_uid)
					},1500)
				}
			}})
		},
		//检查是否记住密码
		checkLoginCookie(){
			var supplierLoginData = this.$cookies.get('supplierLoginData')
			if(supplierLoginData){
				this.remember_pwd = supplierLoginData.remember_pwd
				this.login_phone = supplierLoginData.login_phone
				this.login_pwd = supplierLoginData.login_pwd
			}
		},
		//手机登录记住密码
		setLoginCookie(){
			if(this.remember_pwd && this.login_type == 2){
				var supplierLoginData = {remember_pwd:true,login_phone:this.login_phone,login_pwd:this.login_pwd}
				this.$cookies.set('supplierLoginData',supplierLoginData,'30d')
			}else{
				var supplierLoginData = false
				this.$cookies.set('supplierLoginData',supplierLoginData,'1s')
			}
		},
    refreshCaptcha(){
      this.captcha_url = config.baseApi + '/business/login/captcha?_t=' + new Date().getTime()
    },
	},
	beforeDestroy() {
		clearTimeout(this.checkBindTimer)
	},
}
</script>

<style scoped>
.wrap{background: #fff;}
.head{width: 100%;height: 140px;background: #fff;}
.head .center{display: flex;align-items: center;}
.head .logo{width: 257px;height: 60px;}
.main{width: 100%;height: auto;position: relative;display: flex;}
.main .bg{width: 100%;height: auto;position: relative;z-index: 1;}
.foot{margin: 40px 0;text-align: center;}
.foot>p{font-size: 12px;line-height: 22px;color: #666666;}
.login_main{width: 345px;height: 410px;box-sizing: border-box;padding: 36px 0 28px;background: #fff;position: absolute;top: 145px;right: 230px;z-index: 2;}
.login_main .login_type{padding: 14px 0;border-bottom: 1px solid #eee;display: flex;line-height: 1;}
.login_main .login_type .tab{flex: 1;text-align: center;font-size: 18px;cursor: pointer;}
.login_main .login_type .tab.active{font-weight: bold;color: #fb5758;}
.login_main .code_login{margin: 38px 0 55px;display: flex;flex-direction: column;align-items: center;}
.login_main .code_login .code{width: 155px;height: 155px;}
.login_main .code_login .txt{margin-top: 24px;line-height: 1;font-size: 14px;color: #666666;text-align: center;}
.login_main .account_login{margin: 0 22px 55px;padding-top: 20px;}
.login_main .account_login .change_way{margin-top: 20px;line-height: 1;display: flex;justify-content: space-between;}
.login_main .account_login .change_way>span{font-size: 14px;color: #333333;cursor: pointer;}
.login_main .account_login .login_btn{width: 100%;height: 38px;border-radius: 4px;background: #fb5758;display: flex;justify-content: center;align-items: center;color: #ffffff;font-size: 14px;cursor: pointer;margin-top: 35px;}
.login_main .go_register{margin: 0 30px;text-align: right;font-size: 14px;line-height: 1;}
.login_main .go_register>a{color: #fb5758;text-decoration: underline;cursor: pointer;}
.el_input{display: flex;margin: 14px auto 0 !important;}

</style>
<style>
.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.el_input .el-input__inner:focus{border-color: var(--red);}
.el_input.el_in2 .el-input__inner{padding-left: 90px;}
.el_input .el-input__prefix{left: 2px;top: 1px}
.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;}
.el_input .el-input__suffix{display: flex;}
.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
.lin.el_input .el-input__prefix{display: initial !important;}
</style>